import React from "react";
import { MobileBottomNav } from "./MobileBottomNav";
import { AuthenticatedMobileNavbar } from "./AuthenticatedMobileNavbar";
import { useResponsive } from "@/hooks/useResponsive";

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
  showBottomNav?: boolean;
  showNavbar?: boolean;
  backgroundColor?: string;
  className?: string;
}

export function AuthenticatedLayout({
  children,
  showBottomNav = true,
  showNavbar = true,
  backgroundColor = "#F4E7DA",
  className = ""
}: AuthenticatedLayoutProps) {
  const {
    isIphoneSE,
    isIphoneXR,
    isIphone12,
    isIphone14ProMax,
    isSamsungGalaxy
  } = useResponsive();

  // Tính toán max-width dựa trên loại thiết bị
  const getMaxWidth = () => {
    if (isIphoneSE) return "max-w-[375px]";
    if (isSamsungGalaxy) return "max-w-[360px]";
    if (isIphone12) return "max-w-[390px]";
    if (isIphoneXR) return "max-w-[414px]";
    if (isIphone14ProMax) return "max-w-[428px]";

    return "max-w-md"; // Default max width
  };

  return (
    <div
      className={`min-h-screen pb-20 ${className}`}
      style={{ backgroundColor }}
    >
      <div className={`w-full ${getMaxWidth()} mx-auto flex flex-col min-h-screen`}>
        {showNavbar && <AuthenticatedMobileNavbar />}
        <div className={`${showBottomNav ? 'pb-[75px]' : ''}`}>
          {children}
        </div>
        {showBottomNav && <MobileBottomNav />}
      </div>
    </div>
  );
}

export default AuthenticatedLayout;